export default __webpack_public_path__ + "static/Kristin_Clifford_Digital_BW-e61515b4abaeaf2938639e32055ca512.jpg";